import React, { Fragment, Component } from 'react';
import ReactModal from 'react-responsive-modal';

export const modalStyles = {
  overlay: {
    background: 'rgba(255,255,255,0.8)',
    padding: 0,
  },
  modal: {
    boxShadow: '0 2px 30px rgba(0, 0, 0, 0.07)',
    borderRadius: 10,
  },
  closeButton: {
    display: 'none',
  },
};

export default class Modal extends Component {
  state = {
    open: false,
  };

  onOpen = () => {
    this.setState({ open: true });
  };

  onClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { action, children, close, onClose } = this.props;
    const { open } = this.state;

    return (
      <Fragment>
        {action && React.cloneElement(action, { onClick: this.onOpen })}
        <ReactModal
          styles={modalStyles}
          open={open}
          onClose={onClose || this.onClose}
          center
        >
          {close && (
            <div className="modal-close" onClick={this.onClose}>
              ×
            </div>
          )}
          {children instanceof Function
            ? children({
                onClose: this.onClose,
                onOpen: this.onOpen,
              })
            : children}
        </ReactModal>
      </Fragment>
    );
  }
}

Modal.defaultProps = {
  close: true,
};
